(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-global-footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-footer-top]')) return;
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const target = document.querySelector('#header-group a[href], .rm-standalone-header a[href], main');
    if (target) {
      if (target.tagName === 'MAIN') target.tabIndex = -1;
      target.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmh-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  function init(root = document) {
    root.querySelectorAll('[data-rmh-story]').forEach(card => {
      if (card.dataset.rmhReady) return;
      card.dataset.rmhReady = 'true';
      let frame = 0;
      const reset = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        card.style.removeProperty('--rmh-glow-x');
        card.style.removeProperty('--rmh-glow-y');
      };
      card.addEventListener('pointermove', event => {
        if (!motion.matches || event.pointerType === 'touch' || frame) return;
        frame = requestAnimationFrame(() => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--rmh-glow-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--rmh-glow-y', `${event.clientY - rect.top}px`);
          frame = 0;
        });
      }, { passive: true });
      card.addEventListener('pointerleave', reset);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
